/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentEditActionRotationsInner
 */
export interface DocumentEditActionRotationsInner {
    /**
     * 
     * @type {number}
     * @memberof DocumentEditActionRotationsInner
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentEditActionRotationsInner
     */
    degrees?: number;
}

/**
 * Check if a given object implements the DocumentEditActionRotationsInner interface.
 */
export function instanceOfDocumentEditActionRotationsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DocumentEditActionRotationsInnerFromJSON(json: any): DocumentEditActionRotationsInner {
    return DocumentEditActionRotationsInnerFromJSONTyped(json, false);
}

export function DocumentEditActionRotationsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentEditActionRotationsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'degrees': !exists(json, 'degrees') ? undefined : json['degrees'],
    };
}

export function DocumentEditActionRotationsInnerToJSON(value?: DocumentEditActionRotationsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'degrees': value.degrees,
    };
}

